<template>
  <!--销量组件-->
  <tk-container
    :status="status"
    class="bg-white"
    @refresh="getInit"
  >
    <div style="height: 20px;"></div>
    <div class="m-x-12" v-if="userSales.length">
      <div class="bg-image" :style="`background-image: url(${bgImage}) !important`">
        <div class="decoration-text">{{userSales[0].time}}</div>
        <tk-flex center column>
          <div class="font-13 text-white m-t-24">订单金额</div>
          <div class="font-32 text-white m-t-15"><span class="font-16">￥</span>{{userSales[0].amount}}</div>
        </tk-flex>
      </div>
    </div>
    <template v-if="salesList.length">
      <tk-flex wrap gutter="10" class="p-12">
        <tk-card
          class="p-0 sales-card tk-grid-6"
          :width="100"
          :height="100"
          v-for="(s, index) in salesList"
          :key="index"
        >
          <div class="decoration-text">{{s.time}}</div>
          <tk-flex center column class="full-width">
            <div class="font-13 text-gray m-t-10">订单金额</div>
            <div class="font-bold text-dark m-t-12"><span class="font-10">￥</span>{{s.amount}}</div>
          </tk-flex>
        </tk-card>
      </tk-flex>
    </template>
    <div style="height: 20px;"></div>
  </tk-container>
</template>

<script>
export default {
  props: {
    bgImage: {
      type: String
    },
    salesType: {
      type: String
    }
  },
  data () {
    return {
      status: 'loading', // 页面状态
      userSales: [] // 销量与金额
    }
  },
  computed: {
    salesList () {
      if (!this.userSales.length) { return [] }
      let arr = this.$tkHelper.deepClone(this.userSales)
      arr.splice(0, 1)
      return arr
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
     * @Description: 数据初始化
     * @author xiaozan
     * @date 2020/5/5
     */
    async getInit () {
      try {
        await this.getGroupOrder() // 统计订单销量
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * @Description: 转换一年的起始时间结束时间
     * @author xiaozan
     * @date 2020/5/5
     */
    convertYear (year) {
      return {
        isoStartDate: this.$tkDate(year).startOf('year').toISOString(),
        isoEndDate: this.$tkDate(year).endOf('year').toISOString()
      }
    },
    /**
     * @Description: 转换每个月的起始时间结束时间
     * @author xiaozan
     * @date 2020/5/5
     */
    convertMonth (month) {
      return {
        isoStartDate: this.$tkDate(new Date().getFullYear() + '-' + (month < 10 ? '0' + month : month)).startOf('month').toISOString(),
        isoEndDate: this.$tkDate(new Date().getFullYear() + '-' + (month < 10 ? '0' + month : month)).endOf('month').toISOString()
      }
    },
    /**
     * @Description: 县代终端调用接口
     * @author xiaozan
     * @date 2020/5/5
     */
    transferParse (sum, isoStartDate, isoEndDate) {
      return this.$tkParse.group('/classes/order', 'accountCategory', {
        params: {
          select: {
            sum: {
              $sum: sum
            }
          },
          where: {
            updatedAt: {
              $gte: {
                '__type': 'Date',
                'iso': isoStartDate
              },
              $lte: {
                '__type': 'Date',
                'iso': isoEndDate
              }
            },
            buyUser: this.userInfo.objectId,
            status: { $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped', 'returnExchange'] },
            isDeleted: false
          }
        }
      })
    },
    /**
     * @Description: 统计每年订单销量订单金额
     * @author xiaozan
     * @date 2020/5/5
     */
    async getYearGroupOrder () {
      let endYear = new Date().getFullYear()
      let startYear = 2020
      let diffSum = endYear - startYear
      let arrTime = []
      if (diffSum === 0) { arrTime = [this.convertYear()] }
      if (diffSum > 0) {
        for (let i = 0; i < (endYear - startYear + 1); i++) {
          arrTime.push(this.convertYear((endYear - i).toString()))
        }
      }
      // 每年总金额
      let newAmountArr = []
      arrTime.forEach(s => {
        let a = this.transferParse('orderAmount', s.isoStartDate, s.isoEndDate)
        newAmountArr.push(a)
      })
      let amountArr = await Promise.all(newAmountArr)
      return arrTime.map((s, index) => {
        let m = amountArr[index].data.results
        return {
          time: new Date(s.isoStartDate).getFullYear() + '年',
          amount: m.length ? Number(m[0].sum.toString()).toLocaleString() : 0
        }
      })
    },
    /**
     * @Description: 统计每年订单销量订单金额
     * @author xiaozan
     * @date 2020/5/5
     */
    async getMonthGroupOrder () {
      let endMonth = new Date().getMonth() + 1
      let startMonth = 1
      let diffSum = endMonth - startMonth
      let arrTime = []
      if (diffSum === 0) { arrTime = [this.convertYear()] }
      if (diffSum > 0) {
        for (let i = 0; i < (endMonth - startMonth + 1); i++) {
          arrTime.push(this.convertMonth((endMonth - i).toString()))
        }
      }
      // 每月总金额
      let newAmountArr = []
      arrTime.forEach(s => {
        // let a = this.transferParse('orderAmount', s.isoStartDate, s.isoEndDate)
        let a = this.transferParse('orderAmount', s.isoStartDate, s.isoEndDate)
        newAmountArr.push(a)
      })
      let amountArr = await Promise.all(newAmountArr)
      return arrTime.map((s, index) => {
        let m = amountArr[index].data.results
        return {
          time: (new Date(s.isoStartDate).getMonth() + 1) + '月份',
          amount: m.length ? Number(m[0].sum.toString()).toLocaleString() : 0
        }
      })
    },
    /**
     * @Description: 统计数据
     * @author xiaozan
     * @date 2020/5/5
     */
    async getGroupOrder () {
      if (this.salesType === 'year') {
        this.userSales = await this.getYearGroupOrder()
      } else {
        this.userSales = await this.getMonthGroupOrder()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  // 首个排行背景图
.bg-image {
  width: 100%;
  height: 154px;
  background-repeat:  no-repeat;
  background-size: 100% 154px;
  padding-top: 15px;
  box-shadow:0 3px 35px 0 rgba(0, 0, 0, 0.06);
  .decoration-text {
    width: 60px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-top-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #fece33;
    font-size: 13px;
    color: rgba(140, 72, 42, 1);
  }
}
 // 列表样式
  .sales-card {
    box-shadow:0 3px 35px 0 rgba(0, 0, 0, 0.06);
    .decoration-text {
      width: 60px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;
      background: #FEEFD8;
      font-size: 13px;
      color: rgba(182,141,94,1);
    }
  }
</style>
